export const createMediaQuery = (n: number) =>
  `@media screen and (min-width: ${n}px)`;
